import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Collection } from 'src/app/models/collection.interface';

@Component({
  selector: 'app-edit-name-dialog',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule],
  templateUrl: './edit-name-dialog.component.html',
  styleUrl: './edit-name-dialog.component.scss'
})
export class EditNameDialogComponent {
  collection: Collection;
  newCollectionName = '';

  constructor(
    public dialogRef: MatDialogRef<EditNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditNameDialogComponent
  ) {
    this.collection = data.collection;
  }

  updateCollectionName(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.newCollectionName = input.value;
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();

      this.saveForm();
    }
  }

  saveForm(): void {
    if (!this.newCollectionName || this.collection.name === this.newCollectionName) {
      this.dialogRef.close();
      return;
    }

    this.dialogRef.close(this.newCollectionName);
  }
}
